module.exports = __webpack_public_path__ + "img/PRCA1_Fibroblasts.03897154.png";